import { Box } from '@components/ui/atoms/Box';
import { IconButton } from '@components/ui/atoms/IconButton';
import { ArrowUpIcon, Icon } from '@components/ui/atoms/Icons';
import { WindowTitle } from '@components/ui/atoms/WindowTitle';
import { Global } from '@emotion/react';
import React, { useCallback, useEffect, useState } from 'react';

import { AboutPayments } from './AboutPayments';
import { BannerSection } from './BannerSection';
import { DiverseSupport } from './DiverseSupport';
import { FooterSection } from './FooterSection';
import { MessageData } from './MessageData';
import { PaySection } from './PaySection';
import { ServicesSection } from './ServicesSection';

export const LandingPage: React.FC = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Box minH="100vh" bg="#0B0B0F">
      <WindowTitle title="Bhutan Payments - Secure Payment Gateway" />
      <Global
        styles={{
          'html, body, #root': {
            overflow: 'auto !important',
            height: 'auto !important',
          },
        }}
      />
      {/* Section 1: Main Banner and Navigation */}
      <BannerSection />

      {/* Section 2: About Payments */}
      <AboutPayments />

      {/* Section 3: Services Section */}
      <ServicesSection />

      {/* Section 4: Payment Section */}
      <PaySection />

      {/* Section 5: Diverse Users Support */}
      <DiverseSupport />

      {/* Section 6: Stats and Message Form */}
      <MessageData />

      {/* Footer */}
      <FooterSection />

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <IconButton
          aria-label="Scroll to top"
          onClick={scrollToTop}
          bg="body.50"
          position="fixed"
          bottom="2rem"
          right={{ base: '1rem', md: '2rem' }}
          zIndex={50}
          borderRadius="full"
          boxShadow="0 4px 10px 0 rgba(0, 0, 0, 0.16);"
          w={{ base: '40px', md: '52px' }}
          h={{ base: '40px', md: '52px' }}
          minW={{ base: '40px', md: '52px' }}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Icon width={{ base: '18px', md: '24px' }} height={{ base: '18px', md: '24px' }}>
            <ArrowUpIcon />
          </Icon>
        </IconButton>
      )}
    </Box>
  );
};

LandingPage.displayName = 'LandingPage';
